import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { XIcon, TelegramIcon, DiscordIcon, GitHubCircleSolidIcon, WebsiteIcon, CoinMarketCapIcon, YouTubeIcon, LinkedInIcon, InstagramIcon, FacebookIcon, FrameSourceIcon, GroupIcon, } from '@bnb-chain/icons';
export const useData = () => {
    const { formatMessage, locale } = useIntl();
    return useMemo(() => {
        return {
            Chains: [
                {
                    title: 'BNB Smart Chain',
                    href: `https://www.bnbchain.org/${locale}/bnb-smart-chain`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_chains_bsc',
                },
                {
                    title: 'BNB Greenfield',
                    href: `https://greenfield.bnbchain.org/${locale}`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_chains_gf',
                },
                {
                    title: 'opBNB',
                    href: `https://opbnb.bnbchain.org/${locale}`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_chains_opBNB',
                },
                {
                    title: 'zkBNB',
                    href: `https://zkbnb.bnbchain.org`,
                    target: '_blank',
                    'data-analytics-id': 'x',
                },
            ],
            'Use BNB Chain': [
                {
                    title: 'Download Wallet',
                    href: `https://www.bnbchain.org/${locale}/wallets`,
                    'data-analytics-id': 'click_footer_use_wallets',
                },
                {
                    title: 'Get BNB',
                    href: `https://www.bnbchain.org/${locale}/what-is-bnb`,
                    'data-analytics-id': 'click_footer_use_getBNB',
                },
                {
                    title: 'Stake BNB',
                    href: `https://www.bnbchain.org/${locale}/bnb-staking`,
                    'data-analytics-id': 'click_footer_use_staking',
                },
                {
                    title: 'Bridge Assets',
                    href: `https://www.bnbchain.org/${locale}/bnb-chain-bridge`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_use_bnb-chain-bridge',
                },
                {
                    title: 'Explore dApps',
                    href: `https://dappbay.bnbchain.org?utm_source=Org&utm_medium=Channel&utm_campaign=homepage_240124&utm_content=homepage`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_use_DappBay',
                },
                {
                    title: 'Earn by BTC',
                    href: `https://btcfi.bnbchain.org/`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_use_BTCFi',
                },
                {
                    title: 'Pay by Crypto',
                    href: `https://www.bnbchain.org/${locale}/payment`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_use_payment',
                },
                {
                    title: 'Earn by Liquid Staking',
                    href: `https://www.bnbchain.org/${locale}/liquid-staking`,
                    target: '_self',
                    'data-analytics-id': 'click_footer_use_liquidStaking',
                },
            ],
            Build: [
                {
                    title: 'Portal',
                    href: `https://portal.bnbchain.org/`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_developerPortal',
                },
                {
                    title: 'Documentations',
                    href: 'https://docs.bnbchain.org/',
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_docs',
                },
                {
                    title: 'Faucet',
                    href: 'https://www.bnbchain.org/en/testnet-faucet',
                    'data-analytics-id': 'click_footer_build_faucet',
                },
                {
                    title: 'Dev Tools',
                    href: `https://www.bnbchain.org/${locale}/dev-tools`,
                    'data-analytics-id': 'click_footer_build_devTools',
                },
                {
                    title: 'Submit dApp',
                    href: `https://dappbay.bnbchain.org/submit-dapp`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_submit-dApp',
                },
                {
                    title: 'Greenfield Console',
                    href: `https://dcellar.io/`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_DCellar',
                },
                {
                    title: 'Whitepaper',
                    href: `https://github.com/bnb-chain/whitepaper`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_whitepaper',
                },
                {
                    title: 'BNBChain List',
                    href: `https://www.bnbchainlist.org`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_build_BNBChainList',
                },
            ],
            Participate: [
                {
                    title: formatMessage({ id: 'footer.link.events' }),
                    href: `https://www.bnbchain.org/${locale}/events`,
                    'data-analytics-id': 'click_footer_participate_events',
                },
                {
                    title: formatMessage({ id: 'footer.link.hackathon' }),
                    href: `https://www.bnbchain.org/${locale}/hackathon`,
                    'data-analytics-id': 'click_footer_participate_hackcathon',
                },
                {
                    title: formatMessage({ id: 'footer.link.mvb' }),
                    href: `https://www.bnbchain.org/en/bsc-mvb-program`,
                    'data-analytics-id': 'click_footer_participate_MVB',
                },
                {
                    title: formatMessage({ id: 'footer.link.developer-programs' }),
                    href: `https://www.bnbchain.org/${locale}/developers/developer-programs`,
                    'data-analytics-id': 'click_footer_participate_devProgs',
                },
                {
                    title: formatMessage({ id: 'footer.link.martians-program' }),
                    href: `https://www.bnbchain.org/${locale}/martians-program`,
                    'data-analytics-id': 'click_footer_participate_martiansProgram',
                },
                {
                    title: 'Governance',
                    href: `https://www.bnbchain.org/${locale}/bnb-chain-governance`,
                    'data-analytics-id': 'click_footer_participate_governance',
                },
                {
                    title: formatMessage({ id: 'footer.link.bug-bounty' }),
                    href: 'https://bugbounty.bnbchain.org',
                    target: '_blank',
                    'data-analytics-id': 'click_footer_participate_bugBounty',
                },
                {
                    title: 'Host an Event',
                    href: `https://www.bnbchain.org/${locale}/builders-club`,
                    'data-analytics-id': 'click_footer_participate_builderClub',
                },
                {
                    title: 'Get Workspace',
                    href: `https://www.bnbchain.org/${locale}/space-b`,
                    'data-analytics-id': 'click_footer_participate_builderClub',
                },
                {
                    title: 'Ecosystem Jobs',
                    href: `https://jobs.bnbchain.org/jobs`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_participate_EcosystemJobs',
                },
            ],
            About: [
                {
                    title: 'Blog',
                    href: `https://www.bnbchain.org/${locale}/blog`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_about_blog',
                },
                {
                    title: 'Careers',
                    href: `https://jobs.bnbchain.org/companies/bnb-chain#content`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_about_careers',
                },
                {
                    title: 'BNB Chain Verify',
                    href: `https://www.bnbchain.org/${locale}/official-verification`,
                    'data-analytics-id': 'click_footer_about_verirfication',
                },
                {
                    title: 'Red Alarm',
                    href: `https://dappbay.bnbchain.org/red-alarm/dapp`,
                    target: '_blank',
                    'data-analytics-id': 'click_footer_about_red-alarm',
                },
                {
                    title: 'Privacy Policy',
                    href: `https://www.bnbchain.org/${locale}/privacy-policy`,
                    'data-analytics-id': 'click_footer_about_privacy-policy',
                },
                {
                    title: formatMessage({ id: 'footer.link.terms-of-use' }),
                    href: `https://www.bnbchain.org/${locale}/terms`,
                    'data-analytics-id': 'click_footer_about_tou',
                },
                {
                    title: formatMessage({ id: 'footer.link.contact-us' }),
                    href: `https://www.bnbchain.org/${locale}/contact`,
                    'data-analytics-id': 'click_footer_about_contactUs',
                },
                {
                    title: 'Brand Guidelines',
                    href: `https://www.bnbchain.org/${locale}/brand-guidelines`,
                    'data-analytics-id': 'click_footer_about_brandGuidelines',
                },
            ],
        };
    }, [formatMessage, locale]);
};
export const MediaData = [
    {
        name: 'X (Twitter)',
        href: 'https://twitter.com/BNBChain',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_Twitter',
        icon: XIcon,
    },
    {
        name: 'Telegram',
        href: 'https://twitter.com/BNBChain',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_Twitter',
        icon: TelegramIcon,
        children: [
            {
                name: 'Telegram (Announcement)',
                href: 'https://t.me/bnbchain',
                target: '_blank',
                'data-analytics-id': 'click_footer_community_TelegramAnno',
                icon: FrameSourceIcon,
            },
            {
                name: 'Telegram (Discussion)',
                href: 'https://t.me/BNBchaincommunity',
                target: '_blank',
                'data-analytics-id': 'click_footer_community_TelegramDiscuss',
                icon: GroupIcon,
            },
        ],
    },
    {
        name: 'Discord',
        href: 'https://discord.gg/bnbchain',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_Discord',
        icon: DiscordIcon,
    },
    {
        name: 'GitHub',
        href: 'https://github.com/bnb-chain',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_GitHub',
        icon: GitHubCircleSolidIcon,
    },
    {
        name: 'Forum',
        href: 'https://www.buildnbuild.dev/',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_forum',
        icon: WebsiteIcon,
    },
    {
        name: 'CMC',
        href: 'https://coinmarketcap.com/community/profile/BNBChain',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_CMC',
        icon: CoinMarketCapIcon,
    },
    {
        name: 'YouTube',
        href: 'https://www.youtube.com/channel/UCG9fZu6D4I83DStktBV0Ryw',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_YouTube',
        icon: YouTubeIcon,
    },
    {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/bnbchaininnovation',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_LinkedIn',
        icon: LinkedInIcon,
    },
    {
        name: 'Instagram',
        href: 'https://www.instagram.com/bnbchain/',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_Instagram',
        icon: InstagramIcon,
    },
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/people/BNB-Chain/61550857610291/',
        target: '_blank',
        'data-analytics-id': 'click_footer_community_Facebook',
        icon: FacebookIcon,
    },
];
